import React from 'react';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { getIn } from "formik";
import DeleteIcon from '@mui/icons-material/Delete';
import NumberFormatCustom from '../../common/form/NumberFormatCustom';
import TechCostTyp from '../../common/form/selectbox/TechCostTyp';

const RsltCostForm = ({ formik, index, handleRemove, fieldName = 'rsltCosts', readOnly = false }) => {
    const costTyp = `${fieldName}[${index}].costTyp`;
    const touchedCostTyp = getIn(formik.touched, costTyp);
    const errorCostTyp = getIn(formik.errors, costTyp);

    const costVal = `${fieldName}[${index}].costVal`;
    const touchedCostVal = getIn(formik.touched, costVal);
    const errorCostVal = getIn(formik.errors, costVal);

    const costDesc = `${fieldName}[${index}].costDesc`;
    const touchedCostDesc = getIn(formik.touched, costDesc);
    const errorCostDesc = getIn(formik.errors, costDesc);


    return (
        <TableRow key={index}>
            <TableCell>{index + 1}</TableCell>
            <TableCell >
                <TechCostTyp
                    index={index}
                    formik={formik}
                    touched={touchedCostTyp}
                    errored={errorCostTyp}
                    fieldName={fieldName}
                    filterObject={{
                        blcCd: 'BASE',
                        mlcCd: 'TECH',
                        slcCd: 'COST_TYP',
                    }}
                    fullWidth
                    variant="standard"
                    required
                    name="costTyp"
                    disabled={readOnly}
                />
            </TableCell>
            <TableCell>
                <TextField
                    size="small"
                    required
                    variant="standard"
                    fullWidth
                    name={costVal}
                    value={getIn(formik.values, costVal) ?? ''}
                    helperText={
                        touchedCostVal && errorCostVal
                            ? errorCostVal
                            : ""
                    }
                    error={Boolean(touchedCostVal && errorCostVal)}
                    onChange={(e) =>
                        formik.setFieldValue(costVal, e.target.value)
                    }
                    onBlur={formik.handleBlur}
                    InputProps={{
                        inputComponent: NumberFormatCustom,
                    }}
                    disabled={readOnly}
                />
            </TableCell>
            <TableCell >
                <TextField
                    size="small"
                    required
                    variant="standard"
                    fullWidth
                    name={costDesc}
                    id={costDesc}
                    value={getIn(formik.values, costDesc) ?? ''}
                    helperText={
                        touchedCostDesc && errorCostDesc
                            ? errorCostDesc
                            : ""
                    }
                    error={Boolean(touchedCostDesc && errorCostDesc)}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={readOnly}
                />
            </TableCell>
            <TableCell>
                {readOnly ? null : (
                    <IconButton aria-label="delete" onClick={handleRemove}><DeleteIcon /></IconButton>
                )}
            </TableCell>
        </TableRow>
    )
}

export default RsltCostForm
